import { nationalitiesNames } from "./nationalities"

export const es = {
  //Footer
  "page.footer.exchange": "Intercambio",
  "page.footer.convert": "Convertir",
  "page.footer.launchpad": "Plataforma de lanzamiento",
  "page.footer.wallet": "Billetera",
  "page.footer.support": "Apoyo",
  "page.footer.requestForm": "Formulario de solicitud",
  "page.footer.contactSupport": "Soporte de contacto",
  "page.footer.resources": "Recursos",
  "resource.phone.new_number.please_modify_number_first":
    "Ingresaste un nuevo número, modifícalo primero.",
  "page.footer.downloads": "Descargas",
  "page.footer.mobileApplication": "Aplicación movil",
  "page.footer.buyCrypto": "Comprar cripto",
  "page.footer.referral": "Remisión",
  "page.footer.listingTranding": "Listing Tranding",
  "page.footer.learn": "Aprender",
  "page.footer.whatsTrending": "¿Qué está de moda?",
  "page.footer.productNews": "Noticias de productos",
  "page.footer.events": "Eventos",
  "page.footer.university": "Universidad",
  "page.footer.research": "Investigación",
  "page.footer.marketUpdate": "Actualización del mercado",
  "page.footer.company": "Compañía",
  "page.footer.aboutUs": "Sobre nosotros",
  "page.footer.careers": "Carreras",
  "page.footer.news": "Noticias",
  "page.footer.security": "Seguridad",
  "page.footer.community": "Comunidad",
  "page.footer.announcements": "Anuncios",
  "page.footer.allRightsReserved": "Reservados todos los derechos",
  "page.footer.privacy": "Privacidad",
  "page.footer.terms": "Términos",
  "page.footer.siteMap": "mapa del sitio",
  "page.footer.iosDownload": "Descargar en el",
  "page.footer.androidDownload": "ponlo en",

  // Added :
  "page.header.navbar.blogs": "Blogs",
  "page.header.navbar.launchpad": "Plataforma de lanzamiento",
  "page.header.navbar.exchange": "Intercambio",
  "page.header.navbar.markets": "Mercados",
  "page.header.navbar.convert": "Convertir",
  // 14 FEB
  "page.header.signInToWenbit": "Iniciar sesión en WealthTech",

  "page.markets.trade.marketCoins": "monedas de mercado",

  "page.markets.trade.buy": "Comprar",
  "page.markets.trade.sell": "Vender",
  "page.markets.trade.limit": "Límite",
  "page.markets.trade.market": "Mercado",
  "page.markets.trade.quantity": "Cantidad",
  "page.markets.trade.buyFor": "Comprar para",
  "page.markets.trade.sellFor": "Vender por",
  "page.markets.trade.total": "Total",
  "page.markets.trade.fee": "Tarifa",
  "page.markets.trade.quickBuy": "Compra rapida",
  "page.markets.trade.quickSell": "Venta rápida",

  "page.markets.rows.name": "Nombre de la moneda",
  "page.markets.rows.price": "Precio de la moneda",
  "page.markets.rows.24": "24%",
  "page.markets.rows.24High": "Precio más alto en 24 horas",
  "page.markets.rows.24Low": "Precio más bajo en 24 horas",
  "page.markets.rows.chart": "Cuadro",

  "page.header.navbar.signIn": "Entrar",
  "page.header.navbar.signUp": "Registrarse ahora",
  "page.header.navbar.trade": "Intercambiar",
  "page.header.navbar.mining": " Minería",
  "page.header.navbar.wallets": "Billeteras",
  "page.header.navbar.openOrders": "Órdenes",
  "page.header.navbar.history": "Historia",
  "page.header.navbar.profile": "Perfil",
  "page.header.navbar.logout": " Cerrar sesión",
  "page.body.copy.success": "Texto copiado",
  "page.body.trade.header.markets": "Mercados",
  "page.body.trade.header.markets.content.market": " Mercado",
  "page.body.trade.header.markets.content.pair": "Par",
  "page.body.trade.header.markets.content.price": "Precio",
  "page.body.trade.header.markets.content.last_price": "Último precio",
  "page.body.trade.header.markets.content.change": "Cambio",
  "page.body.trade.header.markets.content.search": "Buscar",
  "page.body.trade.header.markets.content.volume": " Volumen",
  "page.body.trade.header.newOrder": "Formulario de pedido",
  "page.body.trade.header.newOrder.content.tabs.buy": "Comprar",
  "page.body.trade.header.newOrder.content.tabs.sell": "Vender",
  "page.body.trade.header.newOrder.content.orderType": " Órden/Pedido",
  "page.body.trade.header.newOrder.content.orderType.limit": " Límite",
  "page.body.trade.header.newOrder.content.orderType.market": "Mercado",
  "page.body.trade.header.newOrder.content.price": "Precio",
  "page.body.trade.header.newOrder.content.amount": "Cantidad",
  "page.body.trade.header.newOrder.content.total": "Total",
  "page.body.trade.header.newOrder.content.available": "Disponible",
  "page.body.trade.header.newOrder.content.estimatedFee": "Tarifa",
  "page.body.trade.header.marketDepths": "Mercado de fondo",
  "page.body.trade.header.marketDepths.content.price": "Precio",
  "page.body.trade.header.marketDepths.content.volume": "Volumen",
  "page.body.trade.header.marketDepths.content.cumulativeVolume": "Total",
  "page.body.trade.header.marketDepths.content.cumulativeValue":
    "Valor estimado",
  "page.body.trade.header.asks": "Él/Ella pregunta",
  "page.body.trade.header.bids": "Oferta",
  "page.body.trade.orderbook": "Libro de pedido",
  "page.body.trade.orderbook.header.price": "Precio",
  "page.body.trade.orderbook.header.amount": "Cantidad",
  "page.body.trade.orderbook.header.volume": "Volumen",
  "page.body.trade.header.recentTrades": "Historial de intercambio",
  "page.body.trade.header.recentTrades.content.time": " Time ",
  "page.body.trade.header.recentTrades.content.price": "Precio",
  "page.body.trade.header.recentTrades.content.amount": "Cantidad",
  "page.body.trade.header.openOrders": "Ordenes abiertas",
  "page.body.trade.header.openOrders.content.date": "Fecha",
  "page.body.trade.header.openOrders.content.state": " Estado",
  "page.body.trade.header.openOrders.content.price": "Precio",
  "page.body.trade.header.openOrders.content.amount": "Cantidad",
  "page.body.trade.header.openOrders.content.total": "Total",
  "page.body.trade.header.openOrders.content.filled": "Diligenciado",
  "page.body.wallets.estimated_value": "Valor estimado",
  "page.body.wallets.locked": "Cerrado",
  "page.body.wallets.balance": "Balance",
  "page.body.wallets.tabs.deposit": "Deposito",
  "page.body.wallets.tabs.deposit.ccy.message.submit":
    " Enviar el depósito usando la siguiente dirección o el codigo QR. Su depósito será reflejado en su cuenta después de 6 confirmaciones.",

  "page.body.wallets.tabs.deposit.ccy.message.address":
    " Dirección de depósito ",
  "page.body.wallets.tabs.deposit.ccy.message.button": "Copiar",
  "page.body.wallets.tabs.deposit.ccy.message.success": "Copia de dirección",
  "page.body.wallets.tabs.deposit.ccy.message.error":
    " Generando la dirección del depósito, por favor vuelva abrir la pagina si toma mucho tiempo",

  "page.body.wallets.tabs.deposit.fiat.message1":
    "Depósitar usando una trasferencia bancaria",
  "page.body.wallets.tabs.deposit.fiat.message2":
    "Por favor usar las siguientes credenciales para iniciar la transferencia a su banco. Su depósito sera reflejado en su cuenta en 2 dias hábiles",
  "page.body.wallets.tabs.deposit.fiat.bankName": "Nombre del banco",
  "page.body.wallets.tabs.deposit.fiat.accountNumber": "Numero de la cuenta",
  "page.body.wallets.tabs.deposit.fiat.accountName": "Nombre de la cuenta",
  "page.body.wallets.tabs.deposit.fiat.branchNumber": "Numero de sucursal",
  "page.body.wallets.tabs.deposit.fiat.branchAddress": "Dirección de sucursal",
  "page.body.wallets.tabs.deposit.fiat.swiftCode": " El código Swift",
  "page.body.wallets.tabs.deposit.fiat.phoneNumber": "Numero de telefono",
  "page.body.wallets.tabs.deposit.fiat.referenceCode":
    "Su código de referencia",
  "page.body.wallets.tabs.deposit.fiat.etrans_message1":
    "Deposite usando un correo de transferencia",
  "page.body.wallets.tabs.deposit.fiat.etrans_message2":
    "Por favor usar las siguientes credenciales para iniciar la transferencia a su banco. Su depósito sera reflejado en su cuenta en 2 dias hábiles",
  "page.body.wallets.tabs.deposit.fiat.etrans_email": "Correo electronico ",
  "page.body.wallets.table.pending": "Pendiente ",
  "page.body.wallets.tabs.deposit.fiat.admin":
    " Para iniciar la autorizacion de retiro, por favor comunicarse con servicio al cliente",
  "page.body.wallets.tabs.deposit.fiat.email": "Correo electronico ",
  "page.body.wallets.tabs.withdraw": "Retiro",
  "page.body.wallets.tabs.withdraw.content.address": "Dirección de retiro",
  "page.body.wallets.tabs.withdraw.content.amount": "Cantidad del retiro ",
  "Page.body.wallets.tabs.withdraw.content.balance": "Balance disponible ",

  "page.body.wallets.tabs.withdraw.content.code2fa":
    "Codigo Segundo factor de autentificacion",
  "page.body.wallets.tabs.withdraw.content.fee": "Tarifa",
  "page.body.wallets.tabs.withdraw.content.total": "Monto total de retiro",
  "page.body.wallets.tabs.withdraw.content.button": " Retiro ",
  "page.body.wallets.tabs.withdraw.content.addressPlaceholder":
    "Dirección de retiro",
  "page.body.wallets.tabs.withdraw.modal.confirmation": "Confirmación",
  "page.body.wallets.tabs.withdraw.modal.message1": "  Usted recibira",
  "page.body.wallets.tabs.withdraw.modal.button.cancel": " Cancelar",
  "page.body.wallets.tabs.withdraw.modal.button.withdraw": "  Retiro",
  "page.body.wallets.tabs.withdraw.content.enable2fa":
    "Pare retirar tiene que habilitar Segundo factor de autentificacion",
  "page.body.wallets.tabs.withdraw.content.enable2faButton":
    "Habilitar Segundo factor de autentificacion",
  "page.body.openOrders.tab.all": "Historial de ordenes",
  "page.body.openOrders.tab.open": "اOrdenes abiertas",
  "page.body.openOrders.header.orderType": "Orden",
  "page.body.openOrders.header.orderType.buy.market": " Comprar en el mercado",
  "page.body.openOrders.header.orderType.buy.limit": "Limite de compra",
  "page.body.openOrders.header.orderType.sell.market": "Vender el mercado ",
  "page.body.openOrders.header.orderType.sell.limit": "Limite de venta",
  "page.body.openOrders.header.pair": "Par",
  "page.body.openOrders.header.amount": "Cantidad",
  "page.body.openOrders.header.price": "Precio",
  "page.body.openOrders.header.executed": "Ejecutado",
  "page.body.openOrders.header.remaining": "Restante",
  "page.body.openOrders.header.costRemaining": "Costo restante",
  "page.body.openOrders.header.status": "Estado",
  "page.body.openOrders.content.status.done": "Ejecutado",
  "page.body.openOrders.content.status.approve": "Pending",
  "page.body.openOrders.content.status.reject": "Rejected",
  "page.body.openOrders.content.status.wait": "Abierto",
  "page.body.openOrders.content.status.cancel": "Detenido",
  "page.body.openOrders.header.button.cancelAll": " Detener todo  ",
  "page.body.history.deposit": "Historial de deposito ",
  "page.body.history.deposit.header.txid": "  Numero de identificacion",
  "page.body.history.deposit.header.date": " Fecha",
  "page.body.history.deposit.header.currency": "Moneda",
  "page.body.history.deposit.header.amount": "Cantidad",
  "page.body.history.deposit.header.status": "Estado",
  "page.body.history.deposit.content.status.accepted": "Aceptado",
  "page.body.history.deposit.content.status.collected": "Recogido",
  "page.body.history.deposit.content.status.submitted": "Enviado",
  "page.body.history.deposit.content.status.canceled": "Cancelado",
  "page.body.history.deposit.content.status.rejected": "Rechazado",
  "page.body.history.deposit.content.status.skipped": "Saltado",
  "page.body.history.withdraw": "Historial de retiro",
  "page.body.history.withdraw.header.id": "Numero de indentificación",
  "page.body.history.withdraw.header.date": "Fecha",
  "page.body.history.withdraw.header.currency": "Moneda",
  "page.body.history.withdraw.header.address": "Dirección",
  "page.body.history.withdraw.header.amount": "Cantidad",
  "page.body.history.withdraw.header.fee": "Tarifa",
  "page.body.history.withdraw.header.status": "Estado",
  "page.body.history.withdraw.content.status.prepared": "Preparado",
  "page.body.history.withdraw.content.status.submitted": " Enviado",
  "page.body.history.withdraw.content.status.canceled": "Cancelado",
  "page.body.history.withdraw.content.status.accepted": "  Aceptado",
  "page.body.history.withdraw.content.status.suspected": "Presunto",
  "page.body.history.withdraw.content.status.rejected": "Rechazado",
  "page.body.history.withdraw.content.status.processing": "Procesando ",
  "page.body.history.withdraw.content.status.succeed": "Logar/Dar resultado",
  "page.body.history.withdraw.content.status.failed": "Fallido",
  "page.body.history.withdraw.content.status.confirming": "Confirmando",
  "page.body.history.withdraw.content.status.errored": "Error",
  "page.body.history.trade": "Historial de cambio",
  "page.body.history.trade.header.id": "Numero de identificación",
  "page.body.history.trade.header.date": "Fecha",
  "page.body.history.trade.header.side": "Costado",
  "page.body.history.trade.content.side.buy": "Comprar",
  "page.body.history.trade.content.side.sell": "Vender",
  "page.body.history.trade.header.market": "Mercado",
  "page.body.history.trade.header.price": "Precio",
  "page.body.history.trade.header.funds": "Fondos",
  "page.body.history.trade.header.amount": "Cantidad",
  "page.body.history.trade.header.balance": "Balance",
  "page.body.profile.kyc.content":
    "Para cumplir con la regulación, el participante deberá pasar por una verificación de identidad",
  "page.body.profile.kyc.content.notice":
    "Proceso de conocer al cliente (KYC) verificacción requerida por retiro",
  "page.body.profile.kyc.button.success":
    "Proceso de conocer al cliente (KYC) verificacción requerida por retiro",
  "page.body.profile.kyc.button.pending":
    " Proceso de conocer al cliente (KYC) pediente",
  "page.body.profile.kyc.button.fail":
    " Proceso de conocer al cliente (KYC) comienzo",
  "page.body.profile.header.account": " Perfil",
  "page.body.profile.header.account.content.password": "Contraseña ",
  "page.body.profile.header.account.content.password.button.change": "Cambiar",
  "page.body.profile.header.account.content.password.old": "Contraseña antigua",
  "page.body.profile.header.account.content.password.new": "Contraseña nueva",
  "page.body.profile.header.account.content.password.button.save": "Guardar",
  "page.body.profile.header.account.content.password.button.cancel": "Cancelar",
  "page.body.profile.header.account.content.password.conf":
    "Confirmación de contraseña",
  "page.body.profile.header.account.content.password.dont.match":
    "Contraseñas no coinciden",
  "page.body.profile.header.account.content.password.change.success":
    "Logar/Dar resultado",
  "page.body.profile.header.account.content.password.change":
    "Cambiar contraseña",
  "page.body.profile.header.account.content.twoFactorAuthentication":
    " Segundo factor de autentificacion",
  "page.body.profile.header.account.content.twoFactorAuthentication.message.enable":
    "Habilitar",
  "page.body.profile.header.account.content.twoFactorAuthentication.message.disable":
    "Deshabilitar",
  "page.body.profile.header.account.content.twoFactorAuthentication.header":
    "Autentificacion de Google ",
  "page.body.profile.header.account.content.twoFactorAuthentication.message.1":
    "Descargue e instale la aplicación Google Authenticator desde",
  "page.body.profile.header.account.content.twoFactorAuthentication.message.or":
    " O",
  "page.body.profile.header.account.content.twoFactorAuthentication.message.2":
    "Escanear el codigo QR o usar el código secreto Save this secret in a secure location. This code can be used to gain 2FA access from a different device - Guarde este secreto en un lugar seguro. Este código se puede utilizar para obtener acceso al segundo factor de autentificacion desde un dispositivo diferente",
  "page.body.profile.header.account.content.twoFactorAuthentication.message.3":
    "Codigo secreto",
  "page.body.profile.header.account.content.twoFactorAuthentication.message.mfa":
    "Ingresar Segundo factor de autentificación desde la app",
  "page.body.profile.header.account.content.twoFactorAuthentication.message.4":
    "Ingresar Segundo factor de autentificación desde la app",
  "page.body.profile.header.account.content.twoFactorAuthentication.subHeader":
    " Codigo de segundo factor de autentificacion",
  "page.body.profile.header.account.content.twoFactorAuthentication.enable":
    "Habilitar",
  "page.body.profile.header.account.content.twoFactorAuthentication.disable":
    "Deshabilitar Segundo factor de autentificacion",
  "page.body.profile.header.account.content.twoFactorAuthentication.modalBody":
    " Por favor contactar administrador para habilitar",
  "page.body.profile.header.account.content.twoFactorAuthentication.modalHeader":
    "Segundo factor de autentificación está habilitado",
  "page.body.profile.header.account.profile": "Verificación de perfil",
  "page.body.profile.header.account.profile.email.title": "Correo verificado",
  "page.body.profile.header.account.profile.email.message":
    " Deposito/Retiro habilitado",
  "page.body.profile.header.account.profile.phone.unverified.title":
    "Verificacion de telefono",
  "page.body.profile.header.account.profile.phone.title": "Telefono verificado",
  "page.body.profile.header.account.profile.phone.message":
    "Deposito/Intercambio habilitado",
  "page.body.profile.header.account.profile.identity.unverified.title":
    "Verificacion de identidad",
  "page.body.profile.header.account.profile.identity.title":
    "Identidad verificada",
  "page.body.profile.header.account.profile.identity.message":
    "Retiro habilitado",
  "page.body.profile.header.referralProgram": "Enlace de referencia",
  "page.body.profile.content.copyLink": "Copiar",
  "page.body.profile.apiKeys.header":
    "Las llaves de Interfaz de programación de aplicaciones",
  "page.body.profile.apiKeys.header.create": "Crear uno nuevo ",
  "page.body.profile.apiKeys.noOtp":
    " Por favor habilitar segundo factor de autentificación",
  "page.body.profile.apiKeys.show": "Mostrar",
  "page.body.profile.apiKeys.noKeys":
    "Usted no tiene llaves de Interfaz de programación de aplicaciones",
  "page.body.profile.apiKeys.modal.btn.show": " Mostar",
  "page.body.profile.apiKeys.modal.btn.create": " Confirmar",
  "page.body.profile.apiKeys.modal.btn.copy": "Copiar",
  "page.body.profile.apiKeys.modal.btn.activate": "Activar",
  "page.body.profile.apiKeys.modal.btn.disabled": "Deshabilitar",
  "page.body.profile.apiKeys.modal.btn.delete": "Borrar",
  "page.body.profile.apiKeys.modal.header":
    "Verificación del segundo factor de autentificacion",
  "page.body.profile.apiKeys.modal.created_header": "Creado",
  "page.body.profile.apiKeys.modal.access_key": "Llave de acceso",
  "page.body.profile.apiKeys.modal.secret_key": "Llave secreta",
  "page.body.profile.apiKeys.modal.secret_key_info":
    "Esta información se mostrará solo una vez y no se podrá recuperar una vez que se pierda",
  "page.body.profile.apiKeys.modal.secret_key_store": "Guárdelo correctamente",
  "page.body.profile.apiKeys.modal.note": "Nota",
  "page.body.profile.apiKeys.modal.note_content":
    " Para evitar la pérdida de activos, no revele su clave secreta y su clave privada a otras personas. Si olvida su clave secreta, elimínela y solicite un nuevo par de claves secretas ",

  "page.body.profile.apiKeys.modal.title":
    "Entre el código del segundo factor de autentificación en la aplicacion",
  "page.body.profile.apiKeys.modal.label":
    "Código de autenticación de Google de 6 dígitos",
  "page.body.profile.apiKeys.modal.placeholder": " Entre el codigo   ",
  "page.body.profile.apiKeys.table.header.kid": " Niño/Niña",
  "page.body.profile.apiKeys.table.header.algorithm": "Algoritmo",
  "page.body.profile.apiKeys.table.header.state": "Estado",
  "page.body.profile.apiKeys.table.header.created": "Creado",
  "page.body.profile.apiKeys.table.header.updated": "Actualizado",
  "success.api_keys.fetched":
    "Claves de Interfaz de programación de aplicaciones obtenidas con éxito ",
  "success.api_keys.created":
    "Claves de Interfaz de programación de aplicaciones han sido creadas",
  "success.api_keys.copied.access": " Acceso de llave ha sido copiada",
  "success.api_keys.copied.secret": " Llave secreta ha sido copiada",
  "success.api_keys.updated":
    " Interfaz de programación de aplicaciones ha sido actualizada",
  "success.api_keys.deleted":
    " Interfaz de programación de aplicaciones ha sido liminada ",
  "page.body.profile.header.accountActivity": "Actividad de cuenta",
  "page.body.profile.header.accountActivity.content.date": "Fecha",
  "page.body.profile.header.accountActivity.content.addressip": "Niño/Niña",
  "page.body.profile.header.accountActivity.content.action": "Algoritmo",
  "page.body.profile.header.accountActivity.content.result": "Resultado",
  "page.body.profile.header.accountActivity.content.userAgent":
    " Agente de usuario",
  "page.body.profile.content.action.login": " Acceso",
  "page.body.profile.content.action.logout": "Cerrar sesión",
  "page.body.profile.content.action.request2fa":
    "Pedir código QR para segundo factor de autentificación",
  "page.body.profile.content.action.enable2fa":
    " Habilitar segundo factor de autentificación",
  "page.body.profile.content.action.login.2fa":
    "Acceso con segundo factor de autentificación",
  "page.body.profile.content.action.requestPasswordReset":
    "Pedir restablecer la contraseña",
  "page.body.profile.content.action.passwordReset": "Restablecer la contraseña",
  "page.body.profile.content.result.succeed": "Triunfar",
  "page.body.profile.content.result.failed": "Fallido",
  "page.body.kyc.phone.head": " Verificar telefono ",
  "page.body.kyc.phone.enterPhone": "Ingresar numero de telefono",
  "page.body.kyc.phone.phoneNumber": "Numero de telefono",
  "page.body.kyc.phone.enterCode": "Ingresar codigo de confirmación",
  "page.body.kyc.phone.code": "Codigo de mensaje ",
  "page.body.kyc.phone.send": "Enviar codigo",
  "page.body.kyc.phone.resend": "Renviar codigo",
  "page.body.kyc.identity.head": "Verificación de identidad ",
  "page.body.kyc.document.head": "Verificación de documento ",
  "page.body.kyc.identity.firstName": "Nombre",
  "page.body.kyc.identity.lastName": "Apellido",
  "page.body.kyc.identity.dateOfBirth": "Fecha de Nacimiento DD/MM/AAAA",
  "page.body.kyc.identity.residentialAddress": " Dirección de residencia ",
  "page.body.kyc.identity.city": "Ciudad ",
  "page.body.kyc.identity.postcode": "Codigo postal ",
  "page.body.kyc.identity.nationality": " Cuidadania ",
  "page.body.kyc.identity.CoR": " Pais de residencia ",
  "page.body.kyc.documents.expiryDate": "Fecha de expiración DD/MM/AAAA",
  "page.body.kyc.documents.drag": "Arrastrar y soltar o buscar archivos",
  "page.body.kyc.documents.maxFile": " El tamaño maximo de archivo es 10MB ",
  "page.body.kyc.documents.maxNum": " El numero maximo de archivos es 5",
  "page.body.kyc.documents.files": "Tipo de archive permitido: jpg, jpeg, png",
  "page.body.kyc.documents.upload": "Subir foto de indentificación",
  "page.body.kyc.documents.select.passport": "Pasaporte ",
  "page.body.kyc.documents.select.identityCard": "Trajeta de indentificación",
  "page.body.kyc.documents.select.driverLicense": " Licensia de conducción",
  "page.body.kyc.documents.select.utilityBill":
    "Factura de servicios públicos ",
  "page.body.kyc.documents.number": " Numero ",
  "page.body.kyc.documentsType": "Tipo de documento ",
  "page.body.kyc.next": "Siguiente ",
  "page.body.kyc.submit": " Presentar ",
  "page.body.kyc.head.phone": "Verificación de teléfono ",
  "page.body.kyc.head.identity": "Verificación de identidad ",
  "page.body.kyc.head.document": "Verificación de documento ",
  "page.body.kyc.error": "por favor verifique su KYC",
  "page.footer.legalDocuments": "Documentos legales",
  "page.footer.faq": "Preguntas frequentes",
  "page.header.signIn": " Acceso",
  "page.header.signIn.email": " Correo electronico  ",
  "page.header.signIn.password": "Contraseña ",
  "page.header.signIn.password.message.error": "Contraseña invalida ",
  "page.header.signIn.receiveConfirmation":
    "No recibio su correo de confirmación",
  "page.header.signIn.forgotPassword": "Olvido su contraseña",
  "page.header.signIn.resetPassword.title": "Cambiar contraseña",
  "page.header.signIn.resetPassword.oldPassword": "Contraseña anterior",
  "page.header.signIn.resetPassword.newPassword": " Nueva contraseña",
  "page.header.signIn.resetPassword.repeatPassword": " Repetir contraseña",
  "page.header.signIn.resetPassword.button": "Cambiar",
  "page.header.signIn.resetPassword.error":
    "Los campos estan vacios o no coincide ",
  "page.header.signUp": "Vamos a declarar con registro ",
  "page.header.signUp.email": "Correo electronico",
  "page.header.signUp.email.message.error":
    "El correo electronico es invalido ",
  "page.header.signUp.usernameLength.message.error":
    "El nombre de usuario debe tener un mínimo de 4 y un máximo de 20 caracteres",
  "page.header.signUp.password": "Contraseña",
  "page.header.signUp.password.message.error":
    "La contraseña debe al menos contener 8 caracteres, al menos una mayuscula y un digito",
  "page.header.signUp.confirmPassword": "Confirmar contraseña",
  "page.header.signUp.confirmPassword.message.error":
    " Las contraseñas no coinciden",
  "page.header.signUp.referalCode": "Codigo de referencia ",
  "page.header.signUp.terms": "He leido y aceptado los",
  "page.header.signUp.modal.header": "Verifique si correo electronico",
  "page.header.signUp.modal.body":
    " Para completar el registro, busque un correo electronico en su bandeja de entrada con mas información. Si no puede encontrar el correo electrónico, consulte su carpeta de correo no deseado.",
  "page.resendConfirmation": " Renviar confirmación",
  "page.forgotPassword": "Olvido su contraseña",
  "page.forgotPassword.message":
    "Escriba correo electrónico para cambiar contraseña",
  "page.password2fa": "Verificación de segundo factor de autentificación",
  "page.password2fa.message":
    "Escriba el código de segundo factor de autentificación desde la aplicación",
  "page.forgotPassword.email": "Correo electronico ",
  "page.forgotPassword.send": "Enviar",
  "page.noDataToShow": "No hay datos para mostrar ",
  "page.modal.withdraw.success": "Exito",
  "page.modal.withdraw.success.message.content":
    "Su solicitud de retiro ha sido recibida",
  "page.modal.withdraw.success.button": "Muy bien",
  // success messages
  "success.logout": "Cierre de sesión automatico exitoso ",
  "success.documents.accepted":
    "La carga de documentos se realizó correctamente",
  "success.documents.fetched": "Los documentos se recuperaron correctamente",
  "success.withdraw.action": "Solicitud de retiro ha sido recibida",
  "success.otp.enabled": "Segundo factor de autentificación fue habilitado ",
  "success.password.changed": "Contraseña ha sido cambiada",
  "success.payable_currency.updated": " Moneda ha sido actualizada ",
  "error.currency_already_assigned": "Moneda ya asignada",
  "success.password.forgot":
    "Se ha enviado un enlace para restablecer la contraseña a su correo electrónico",
  "success.password.changed.successfuly": "Contraseña ha cambiado ",
  "success.order.canceled": "Orden ha sido cancelada",
  "success.order.canceled.all": "Todas las ordines han sido canceladas ",
  "success.order.created": "Orden ha sido creada",
  "success.phone.verification.send":
    "El codigo de verificación ha sido enviado a su teléfono ",
  "success.phone.confirmed": "Su telefono ha sido confirmado ",
  "success.message.sent": "Mensaje enviado ",
  "success.email.confirmed":
    "Su dirección de correo electrónico ha sido confirmada con éxito // mensajes de error // barong",
  "resource.labels.private": "  No se puede actualizar la etiqueta ",
  "resource.user.no_activity": "No se registró actividad o tema incorrecto",
  "resource.profile.not_exist": "Usuario no tiene perfil ",
  "resource.profile.exist": "Este perfil ya existe  ",
  "resource.api_key.2fa_disabled":
    "Solo cuentas con el Segundo factor de autentificación habilitado permitido ",
  "resource.api_key.missing_otp":
    "La cuenta ha habilitado el Segundo factor de auntentificación pero falta un código de par verdadero",
  "resource.api_key.invalid_otp": "Codigo de par verdadero es invalido ",
  "resource.phone.twillio": " Algo salio mal con el Cliente Twilio",
  "resource.phone.invalid_num": "El numero de telefono es invalido ",
  "resource.phone.exists": "El numero de teléfono ya exisiste",
  "resource.phone.number_exist":
    "Telefono no encontrado, o codigo de verificación es invalido ",
  "resource.phone.verification_invalid":
    "Número máximo de documentos ya alcanzado",
  "resource.documents.limit_reached":
    "La cantidad de documentos alcanzará el límite con esta carga",
  "resource.documents.limit_will_be_reached":
    "El Segundo factor de autorización ha sido habilitado para esta cuenta ",
  "resource.otp.already_enabled": "Active el especial 2FA con este cálculo",
  "resource.otp.invalid": " Codigo de par verdadero es invalido",
  "resource.password.doesnt_match": "Las nuevas contraseñas no coinciden ",
  "resource.password.prev_pass_not_correct":
    "La contraseña anterior no es correcto",
  "resource.password.no_change_provided":
    "La nueva contraseña no puede ser la misma que la anterior",
  "resource.document.empty_doc_expire": "La fecha de expedición es invalido ",
  "password.requirements":
    "La contraseña no cumple con los requisites minimos ",
  "password.password.password_strength":
    " La contraseña es demasiado débil, aumente la longitud o complejidad de la contraseña. Correo electrónico tomado. ",

  "email.taken": "Correo electrónico ya en uso.",
  "email.invalid": "Email inválido",

  "identity.user.invalid_referral_format":
    "Formato de identificador único de referencia no valido ",
  "identity.user.referral_doesnt_exist": "La referencia no exisiste ",
  "identity.user.active_or_doesnt_exist":
    "Usuario no exisiste o ya se ha activado ",
  "identity.password.user_doesnt_exist": "Usuario no exisiste",
  "identity.user.passwords_doesnt_match": " Las contraseñas no coinciden",
  "identity.user.utilized_token": "JSON Web Tokens ya se ha utilizado",
  "identity.session.invalid_login_params":
    "Correo electronico o contraseña invalid ",
  "identity.session.invalid": "Sesión invalida ",
  "identity.captcha.required": "Se requiere respuesta Captcha",
  "identity.captcha.mandatory_fields":
    " Los campos obligatorios deben completarse",
  "identity.session.not_active": "Su cuenta no esta activa",
  "identity.session.banned": "Su cuenta is prohibida ",
  "identity.session.invalid_params": "Correo electronico o contraseña invalid",
  "identity.session.missing_otp":
    "اکاؤنٹ نے 2fA کو فعال کیا ہے لیکن او ٹی پی کوڈ غائب ہے",
  "identity.session.invalid_otp": "Codigo de par verdadero es invalido",
  "first_name.invalid": "El nombre es invalido",
  "last_name.invalid": "El apellido es invalido",
  "city.invalid": " La ciudad es invalida ",
  "postcode.invalid": "El codigo postal es invalido ",
  "address.invalid": "La dirección es invalida",
  "first_name.blank": "Falta el nombre o esta vacio ",
  "last_name.blank": " Falta el apellido o esta vacio",
  "dob.blank": " Fecha de Nacimiento es invalido",
  "address.blank": "Falta la dirección o esta vacio ",
  "city.blank": "Falta la ciudad o esta vacio ",
  "country.blank": "Falta el pais o esta vacio ",
  "postcode.blank":
    "Postcode.blank Código postal. falta el espacio en blanco o está vacío",
  "country.must have alpha2 or alpha3 format":
    "país. Debe tener formato alpha2 o alpha3",
  "totp.error": "Codigo de par verdadero es invalido",
  "record.not_found": "No se encuentra el registro",
  "jwt.decode_and_verify": "Error al decodificar y verificar JWT",
  "authz.invalid_session": "Error al decodificar las cookies",
  "authz.user_not_active": " El usuario no esta activo ",
  "authz.invalid_signature":
    "El encabezado de la clave de la interfaz de programación de aplicaciones Firma no es válido",
  "authz.apikey_not_active":
    "La clave de la interfaz de programación de aplicaciones esta inactiva ",
  "authz.disabled_2fa":
    "El propietario de la clave de interfaz de programación de aplicaciones ha inahabilitado el segundo factor de autentificación",
  "authz.invalid_api_key_headers":
    "Encabezados de clave de interfaz de programación de aplicaciones en blanco o faltantes",
  "authz.permission_denied": "Path está en la lista negra",
  "authz.unexistent_apikey":
    "El encabezado de la clave X-Auth- de interfaz de programación de aplicaciones no es válido, // Errores de validación // Módulo de identidad",
  "identity.user.missing_email": " Falta el correo electronico ",
  "identity.user.empty_email": "Falta el correo electrónico o está vacío",
  "identity.user.missing_password": "Falta la contraseña",
  "identity.user.empty_password": "Falta la contraseña o está vacío",
  "identity.user.missing_token": " Falta el token ",
  "identity.user.empty_token": "Falta el token o está vacío",
  "identity.user.missing_reset_password_token":
    "Falta el token de restablecimiento de contraseña",
  "identity.user.empty_reset_password_token":
    "Falta el token de restablecimiento de contraseña o está vacío",
  "identity.user.missing_confirm_password": "Confirme que falta la contraseña",
  "identity.user.empty_confirm_password":
    "Confirme que falta la contraseña o está vacía",
  "identity.session.missing_emai": "Falta el correo electrónico",
  "identity.session.missing_password": "Falta la contraseña",
  "identity.session.invalid_captcha_format":
    ",Formato captcha no válido // módulo de recursos",
  "resource.otp.missing_code": " Falta el codigo de par verdadero ",
  "resource.otp.empty_code": "Falta el codigo de par verdadero o está vacío  ",
  "resource.labels.missing_key": "Falta la llave",
  "resource.labels.empty_key": "Falta la clave o está vacía",
  "resource.labels.missing_value": "Falta valor",
  "resource.labels.empty_value": "Falta el valor o está vacío",
  "resource.documents.missing_doc_expire":
    "Falta la fecha de vencimiento de los documentos",
  "resource.documents.empty_doc_expire":
    "Falta la fecha de vencimiento de los documentos o está vacía",
  "resource.documents.missing_doc_type": " Falta el tipo de documento",
  "resource.documents.empty_doc_type":
    "Falta el tipo de documento o está vacío",
  "resource.documents.missing_doc_number": "Falta el número de documentos.",
  "resource.documents.empty_doc_number":
    "El número de documentos falta o está vacío.",
  "resource.documents.missing_upload": "Falta el archivo adjunto",
  "resource.user.missing_topic": "Falta el tema",
  "resource.user.empty_topic": "Falta el tema o está vacío",
  "resource.user.missing_old_password": "Falta la contraseña anterior",
  "resource.user.empty_old_password":
    "Falta la contraseña anterior o está vacía",
  "resource.user.missing_new_password": "Falta la nueva contraseña",
  "resource.user.empty_new_password": "Falta la nueva contraseña o está vacía",
  "resource.user.missing_confirm_password": "Confirme que falta la contraseña",
  "resource.user.empty_confirm_password":
    "Confirmar que falta la contraseña o está vacía",
  "resource.profile.missing_first_name": "Falta el nombre",
  "resource.profile.missing_last_name": "Falta el apellido",
  "resource.profile.missing_dob": "Falta la fecha de nacimiento",
  "resource.profile.missing_address": "Falta la dirección",
  "resource.profile.missing_postcode": "Falta el código postal",
  "resource.profile.missing_city": "Falta la ciudad",
  "resource.profile.missing_country": "Falta el país",
  "resource.api_key.missing_algorithm": "Falta el algoritmo",
  "resource.api_key.empty_algorithm": "Falta el algoritmo o está vacío",
  "resource.api_key.empty_kid": " Falta el KID o está vacío",
  "resource.api_key.empty_scope": "Falta el alcance o está vacío",
  "resource.api_key.missing_totp":
    "El código de contraseña de un solo uso basado en el tiempo falta o está vacío",
  "resource.api_key.empty_totp": "TOTP está vacío o falta",
  "resource.api_key.missing_kid": "Falta KID",
  "resource.api_key.empty_state": "Falta el estado o está vacío",
  "resource.phone.missing_phone_number": "Falta el número de teléfono",
  "resource.phone.please.provide.existing.phone.number":
    "Por favor proporcione un número de teléfono existente",
  "resource.phone.empty_phone_number":
    "Falta el número de teléfono o está vacío",
  "resource.phone.missing_verification_code":
    " Falta el código de verificación",
  "resource.phone.empty_verification_code":
    "Falta el código de verificación o está vacío // peatio",
  "account.currency.doesnt_exist": " La moneda no existe",
  "account.deposit.invalid_state": "Estado de depósito no válido",
  "account.deposit.non_integer_limit":
    "No se pudo analizar el valor que envió en un tipo entero",
  "account.deposit.invalid_limit": "Límite no válido",
  "account.deposit.non_positive_page":
    "El valor de la página debe ser positivo",
  "account.deposit.empty_txid":
    "Falta el ID de transacción, el ID de transacción está vacío",
  "account.deposit_address.invalid_address_format":
    "Formato de dirección de depósito no válido",
  "account.deposit_address.doesnt_support_cash_address_format":
    " La moneda no admite el formato de dirección de efectivo",
  "account.withdraw.non_integer_limit":
    "No se pudo analizar el valor límite que envió en un tipo entero",
  "account.withdraw.invalid_limit": "Límite no válido",
  "account.withdraw.non_positive_page":
    "El valor de la página debe ser positivo",
  "account.withdraw.non_integer_otp":
    "  El valor de Codigo de par verdadero no se pudo analizar en un tipo entero",
  "account.withdraw.empty_otp":
    " Falta el código de par verdadero, el código de par verdadero está vacío",
  "account.withdraw.empty_rid": "Rid falta, rid está vacío",
  "account.withdraw.non_decimal_amount":
    " El valor de la cantidad que envió no se pudo analizar en tipo decimal",
  "account.withdraw.non_positive_amount": "Importe El valor debe ser positivo",
  "account.deposit.not_permitted":
    "Los depósitos se permiten después de la verificación telefónica",
  "account.withdraw.not_permitted":
    " Por favor, pase los pasos de verificación correspondientes para retirar fondos.",
  "account.withdraw.insufficient_balance":
    "El saldo de la cuenta es insuficiente",
  "account.withdraw.invalid_amount": "Monto de retiro no válido",
  "account.withdraw.create_error": "No se pudo crear el retiro",
  "account.withdraw.invalid_otp": " Codigo de par verdadero no válido",
  "account.withdraw.disabled_api":
    "La interfaz de programación de la aplicación de retiro está deshabilitada",

  "market.market.doesnt_exist_or_not_enabled": " El mercado no existe",
  "market.order.invalid_state": "Estado de depósito no válido",

  "market.conversion.conversion_error": "Cotización de conversión vencida",

  "market.order.invalid_limit": "Límite no válido",
  "market.order.non_integer_limit":
    "No se pudo analizar el valor límite que envió en un tipo entero",
  "market.trade.empty_page": " Falta la página o está vacía",
  "market.order.invalid_order_by": "Pedido no válido por",
  "market.order.invalid_side": "Orden inválida",
  "market.order.non_decimal_volume":
    " El valor de volumen que envía no se pudo analizar en tipo decimal",
  "market.order.non_positive_volume": "El valor del volumen debe ser positivo",
  "market.order.invalid_type": "Pedido no válido",
  "market.order.non_decimal_price":
    "El valor de volumen que envía no se pudo analizar en tipo decimal",
  "market.order.non_positive_price": "El valor del volumen debe ser positivo",
  "market.order.non_integer_id":
    "l valor de ID que envió no se pudo analizar en tipo entero",
  "market.order.empty_id": "Falta el ID o está vacío",
  "market.trade.non_integer_limit":
    " No se pudo analizar el valor límite que envió en un tipo entero",
  "market.trade.invalid_limit": "Límite no válido",
  "market.trade.non_integer_timestamp":
    "El valor de marca de tiempo que envía no se pudo analizar en un tipo entero",
  "market.trade.empty_timestamp": "alta la marca de tiempo o está vacía",
  "market.trade.invalid_order_by": "Pedido inválido por ",
  "market.order.insufficient_market_liquidity":
    "Liquidez de mercado insuficiente",
  "market.order.invalid_volume_or_price": " Volumen o precio no válido",
  "market.order.create_error": " No se pudo crear el error.",
  "market.order.cancel_error": "No se pudo cancelar el error",
  "market.order.market_order_price": "La orden de mercado no tiene precio",
  "market.trade.not_permitted":
    "Por favor, pase los pasos de verificación correspondientes para habilitar el comercio",
  "market.account.insufficient_balance":
    "El saldo de la cuenta es insuficiente",
  "public.currency.doesnt_exist": "La moneda no existe",
  "public.currency.invalid_type": " Tipo de moneda no válido",
  "public.market.doesnt_exist": " El mercado no existe",
  "public.order_book.non_integer_ask_limit":
    "El valor límite de solicitud que envía no se pudo analizar en un tipo entero",
  "public.order_book.invalid_ask_limit": "Límite de oferta no válido",
  "public.order_book.non_integer_bid_limit":
    "El valor límite que envía no se pudo analizar en tipo entero",
  "public.order_book.invalid_bid_limit": "Límite no válido",
  "public.trade.non_integer_limit": "El valor de la página debe ser positivo",
  "public.trade.invalid_limit":
    "No se pudo analizar el valor de la marca de tiempo que envió en un tipo entero",
  "public.trade.non_positive_page": "Pedido no válido por",
  "public.trade.non_integer_timestamp":
    "No se pudo analizar el valor límite que envió en un tipo entero",
  "public.trade.invalid_order_by": "Límite no válido",
  "public.market_depth.non_integer_limit":
    "El valor límite que envía no se pudo analizar en un tipo entero",
  "public.market_depth.invalid_limit": " Período no válido",
  "public.k_line.non_integer_period":
    " No se pudo analizar el valor límite que envió en un tipo entero",
  "public.k_line.invalid_period": "Falta la hora de Param o está vacía",
  "public.k_line.non_integer_time_from":
    "No se pudo analizar el valor límite que envió en un tipo entero",
  "public.k_line.empty_time_from": "Falta tiempo para param o está vacío",
  "public.k_line.non_integer_time_to":
    " No se pudo analizar el valor límite que envió en un tipo entero",
  "public.k_line.empty_time_to": " Límite no válido",
  "public.k_line.non_integer_limit":
    "El precio específico que está enviando no se pudo analizar como un tipo entero",
  "public.k_line.invalid_limit": "Límite no válido",
  "server.internal_error": "Error interno del servidor",
  "public.trade.tradingChart-label": "Gráfico de negociación",
  "public.trade.marketDepth-label": "Profundidad del mercado",
  "public.trade.Chart-label-parent": "Gráficos",

  //NEW TRANSLATIONS START HERE
  "page.header.navbar.header": "\norte",
  "page.signIn.description":
    "Bienvenido al nombre del intercambio // No cambie el nombre del intercambio",
  "page.signIn.2faRequired":
    "Por favor ingrese el código de segundo factor de autentificación",
  "page.signIn.signup": "Regístrese ahora",
  "page.signIn.signupExists": " No tienes una cuenta",
  "page.forgotPassword.description":
    "Si olvidó su contraseña, le enviaremos instrucciones por correo electrónico para restablecer su contraseña.",
  "page.forgotPassword.back": "Regresar inicio de sesión",
  "page.forgotPassword.signUp": " Regístrese ahora",
  "page.forgotPassword.signUpExists": "No tienes una cuenta",
  "page.body.forget_password": "Olvidé mi contraseña",
  "page.signUp.description":
    "Bienvenido a (nombre de intercambio), no cambie el nombre de intercambio",
  "page.signUp.signin": " Inicie sesión aquí",
  "page.signUp.signinExists": "Ya tengo una cuenta",
  "page.profile": "Perfil",
  "page.profile.profileDetailsTitle": "Detalles de perfil ",
  "page.profile.referralTitle": "Gane con recomendación",
  "page.profile.payableCurrencyPlaceholder":
    "Seleccione su pagadero actualmente",
  "page.profile.referralDescription":
    "Invite a sus amigos y familiares y reciba una bonificación: 15% del valor de la contribución",
  "page.profile.2faTitle": "Autenticación de dos factores",
  "page.profile.2faDescription":
    "La autenticación de dos factores es un método para proteger su cuenta web. Cuando está activado, debe ingresar no solo su contraseña, sino también un código especial. Puede recibir este código en la aplicación móvil. Incluso si una tercera persona encuentra su contraseña, no podrá acceder con ese código.",
  "page.profile.currentStatus": "Estado actual",
  "page.profile.kycTitle":
    "KYC - Verificación de identidad: conozca a su cliente",
  "page.emailAddress": "Dirección de correo electrónico",
  "page.uid": "Identificador único",
  "page.show": "Mostrar",
  "page.hide": "Ocultar ",
  "page.payableCurrency": " Moneda pagadera",
  "page.body.wallet.currencyTitle": "Moneda ",
  "page.body.wallet.currencyName": "Nombre ",
  "page.body.wallet.availableBalance": "Disponible ",
  "page.body.wallet.lockedBalance": "Bloqueado",
  "page.body.wallet.actionTitle": " Acción",
  "page.body.wallet.action.deposit": " Deposito ",
  "page.body.wallet.action.withdraw": " Retiro",
  "page.header.navbar.2fa": "Autenticación de dos factores",
  "page.header.navbar.forgetPassword": " Autenticación de dos factores",
  "page.header.navbar.emailVerification": "Verificación de correo electrónico",
  "page.body.confirm.title": "Comience su verificación de identificación",
  "page.body.confirm.subTitle": "Verifique su identidad.",
  "success.identity.submitted": "Perfil enviado",
  "page.body.profile.content.action.signup": "Regístrese",
  "page.body.profile.beneficiaries.header": "Mis beneficiarios",
  "page.body.profile.beneficiaries.header.create": "Crear nuevo ",
  "page.body.profile.beneficiaries.noBeneficiaries": "No tiene beneficiarios",
  "page.body.profile.beneficiaries.modal.form.selectCurrency":
    "Seleccionar moneda",
  "page.body.profile.beneficiaries.modal.form.name":
    "​​Nombre de referencia del beneficiario",
  "page.body.profile.beneficiaries.modal.form.description":
    "Descripción del beneficiario",
  "page.body.profile.beneficiaries.modal.form.address":
    "Dirección del beneficiario",
  "page.body.profile.beneficiaries.modal.form.accountNumber":
    "Número de cuenta bancaria del beneficiario",
  "page.body.profile.beneficiaries.modal.form.swift":
    "Código swift del banco beneficiario",
  "page.body.profile.beneficiaries.modal.form.fullName":
    "Nombre completo del beneficiario",
  "page.body.profile.beneficiaries.modal.form.submitFailed":
    " Por favor, compruebe si se han completado todos los requisitos.",
  "page.body.profile.beneficiaries.modal.form.alreadyActive":
    "El beneficiario ya está activo, puede eliminarlo.",
  "page.body.profile.beneficiaries.modal.form.activationCode":
    "Código de activación del beneficiario",
  "page.body.profile.beneficiaries.modal.form.deleteConfirm":
    "¿Realmente desea eliminar este beneficiario?",
  "page.body.profile.beneficiaries.modal.btn.show": "Mostrar",
  "page.body.profile.beneficiaries.modal.btn.close": " Cerrar ",
  "page.body.profile.beneficiaries.modal.btn.create": "Confirmar ",
  "page.body.profile.beneficiaries.modal.btn.activate": "Activar",
  "page.body.profile.beneficiaries.modal.btn.disabled": "Desactivar",
  "page.body.profile.beneficiaries.modal.btn.delete": "Eliminar ",
  "page.body.profile.beneficiaries.modal.header": " Gestionar beneficiarios",
  "page.body.profile.beneficiaries.modal.created_header": " Creado ",
  "page.body.profile.beneficiaries.table.header.currency": "Moneda ",
  "page.body.profile.beneficiaries.table.header.description": "Descripción",
  "page.body.profile.beneficiaries.table.header.name": "Nombre ",
  "page.body.profile.beneficiaries.table.header.address":
    " Dirección de cifrado ",
  "page.body.profile.beneficiaries.table.header.swift": " Swift",
  "page.body.profile.beneficiaries.table.header.accountNumber":
    "Número de cuenta",
  "page.body.profile.beneficiaries.table.header.fullName": "Nombre completo",
  "page.body.profile.beneficiaries.table.header.state": "Estado",
  "success.beneficiaries.fetched": "Beneficiarios seleccionados con éxito",
  "success.beneficiaries.created": "Se creó el beneficiario",
  "success.beneficiaries.updated": "Se actualizó el beneficiario",
  "success.beneficiaries.deleted": "Se eliminó al beneficiario",
  "account.beneficiary.non_integer_id":
    "No se encontró la identificación del beneficiario",
  "account.beneficiary.invalid_pin": "Invalid Beneficiary Pin",
  "account.beneficiary.invalid_state_for_withdrawal": "Invalid Beneficiary",
  "page.body.wallets.tabs.withdraw.modal.message2": "Sobre el beneficiario",
  "page.body.wallets.tabs.withdraw.form.toggleLabel": "Beneficiario de uso",
  "page.body.wallets.tabs.withdraw.form.beneficiaryPlaceHolder":
    "Seleccionar beneficiario",
  "page.body.wallets.tabs.withdraw.form.addNewBeneficiary":
    "Agregar nuevo beneficiario",
  "currency.currency_doesnt_exist_or_not_payable":
    " La moneda no existe o no es pagadera",

  "resource.documents.already_expired":
    " Los documentos que intentas cargar ya están caducados",
  "resource.documents.invalid_format":
    " Los documentos deben ser válidos y no estar vencidos.",
  "success.beneficiaries.pinResend":
    "Pin reenviado a su correo electrónico registrado",
  "account.beneficiary.cant_resend_within_1_minute":
    " Pin ya enviado. Espere 1 minuto para reenviar el pin",

  "page.header.navbar.otc": "Sin receta",

  "page.trading.toolbar.progressLabel.lowest24": "Mínimo 24h",
  "page.trading.toolbar.progressLabel.lastPrice": " Último precio",
  "page.trading.toolbar.progressLabel.highest24": " Máxima 24h",
  "page.trading.toolbar.progressLabel.volume24": " Volumen 24h",
  "page.trading.toolbar.progressLabel.change": "Cambiar",

  "page.profile.section.profile.title": "Mi perfil",
  "page.profile.section.referral.title": "Remisión",
  "page.profile.section.accountActivity.title": "Actividad",
  "page.profile.section.api.title":
    "A Interfaz de programación de aplicaciones",
  "page.profile.section.beneficiary.title": "   Beneficiarios",

  "page.signUp.PEP.text": "PEP",
  "page.signUp.termsAndService.text": "Condiciones y servicio",
  "page.signUp.PrivacyPolicy.text": "Política de privacidad",
  "page.footer.accountDeletionPolicy": "Política de eliminación de cuenta",
  "page.signUp.risks.text": "Riesgos relacionados con las criptomonedas",

  "page.header.signUp.username": "  Nombre de usuario",
  "page.sigin.welcomeText": " Empecemos por iniciar sesión",
  "page.signUp.button": "Registrarse",
  "page.wallets.portfolio.text": "Valor total de la cartera",
  "page.wallets.label.hideEmptyWallets": "Ocultar carteras vacías",

  // Additional Transitions Add Below

  "page.history.withdraw.details": "Detalles de devolución",
  "page.history.deposit.details": "Detalles de envío",
  "page.markets.search.text": "Encuentra monedas",
  "page.productMenu.home": "Hogar",
  "page.productMenu.p2p": "P2P",
  "page.auth.welcome.message": "¡Comencemos con el inicio de sesión!",
  "page.body.wallets.min_deposit_warning":
    "El depósito mínimo actualmente es: {min_amount {currency} ",
  "page.body.wallets.mining_deposit_warning":
    "No vaya directamente a su dirección de depósito, ya que esto puede cambiar sin previo aviso. Las reservas perdidas no se acumularán.",
  "page.body.header.markets": "Mercados",
  "page.body.header.charts": "Gráficos",
  "page.body.header.myOrders": "Mis ordenes",
  "page.body.header.trades": "Comercio",
  "page.body.header.orders": "pedidos",
  "page.body.header.buySell": "Comprando y vendiendo",

  "page.body.wallets.noWallets": "No se encontraron carteras",
  "page.body.dark.version": "Versión negra",

  "page.productMenu.market": "Mercado",
  "page.productMenu.exchange": "Intercambio",
  "page.productMenu.app": "Aplicación",
  "page.productMenu.cards": "Tarjetas",
  "page.productMenu.mining": "Minería",
  "page.productMenu.staking": "Replanteo",
  "page.productMenu.defi": "DeFi",
  "page.productMenu.convert": "Convert",

  "username.too_long": "El nombre de usuario es demasiado largo",
  "username.too_short": "El nombre de usuario es demasiado corto",

  "account.update.sms_authentication_failed.resend_otp_again":
    "Algo salió mal, por favor verifica los códigos",

  ...nationalitiesNames
}
